import { ScrollLink, SCROLL_DURATION } from './components/link';
import { ScrollElement } from './components/element';

export { ScrollLink, ScrollElement, SCROLL_DURATION };
